<h5 class="label">Mode de livraison</h5>

<nz-space nzSize="large">
  <div nz-row nzGutter="16" class="delivery-options">
    <!-- Livraison à domicile -->
    <div
      nz-col
      class="delivery-card"
      [class.selected]="initialPickupState === false"
      [class.disabled]="initialPickupState === false || isLoadingShip"
      (click)="homeDelivery()"
    >
      <span nz-icon nzType="home" nzTheme="outline" class="delivery-icon"></span>
      <div class="delivery-text">Livraison à domicile</div>
      <span
        *ngIf="initialPickupState === true"
        nz-icon
        nzType="check-circle"
        nzTheme="filled"
        class="check-icon"
      ></span>
    </div>

    <!-- Livraison point relais -->
    <div
      nz-col
      class="delivery-card"
      [class.selected]="initialPickupState === true"
      [class.disabled]="initialPickupState === true"
      (click)="!initialPickupState && showModal()"
    >
      <span nz-icon nzType="shop" nzTheme="outline" class="delivery-icon"></span>
      <div class="delivery-text">Livraison en point relais</div>
      <span
        *ngIf="initialPickupState === false"
        nz-icon
        nzType="check-circle"
        nzTheme="filled"
        class="check-icon"
      ></span>
    </div>
  </div>
</nz-space>

<nz-modal
  [(nzVisible)]="openModal"
  (nzOnCancel)="onClose()"
  (nzAfterOpen)="initializeWidget()"
  [nzCentered]="isCentered"
  [nzFooter]="null"
  [nzStyle]="{ width: 'auto' }"
  [nzClosable]="!isLoading"
>
  <ng-container *nzModalContent>
    <div *ngIf="isLoading" class="loading-spinner">
      <nz-spin nzTip=""></nz-spin>
    </div>
    <div id="monIdDeWidgetColissimo"></div>
  </ng-container>
</nz-modal>

<!-- Adresse du point relais sélectionné -->
<div *ngIf="initialPickupState" class="pickup-address-container">
  <div *ngFor="let line of initialPickupAdress" class="pickup-address-line">{{ line }}</div>
</div>

<div *ngIf="selectPoint" class="pickup-info-container">
  <div *ngFor="let field of ['nom', 'adresse1', 'codePostal', 'localite', 'libellePays']" class="pickup-info-line">
    {{ selectPoint[field] }}
  </div>

  <div class="button-options">
    <div nz-row nzJustify="end">
      <button class="button-sub-options" nz-button nzType="default" (click)="restorePickupState()">Annuler</button>
      <button nz-button class="bemum-rose" nzType="default" (click)="updateShipping()">Enregistrer</button>
    </div>
  </div>
</div>
